import { FC } from 'react'
import Link from 'next/link'
import classNames from 'classnames'
import styles from './index.module.scss'

type Props = {
  label: string
  href: string
  isActive?: boolean
  isChecked?: boolean
  withCheckmark?: boolean
}

export const SettingsSidebarMenuItem: FC<Props> = ({ label, href, isActive, isChecked, withCheckmark }) => {
  if (withCheckmark) {
    return (
      <Link href={href}>
        <a>
          <div
            className={classNames(styles.item, {
              [styles.active]: isActive,
              [styles.check]: !isChecked,
              [styles.checked]: isChecked,
            })}
          >
            {label}
          </div>
        </a>
      </Link>
    )
  }

  return (
    <Link href={href}>
      <a>
        <div
          className={classNames(styles.item, {
            [styles.active]: isActive,
          })}
        >
          {label}
        </div>
      </a>
    </Link>
  )
}
